import { gql } from '@apollo/client';

export const STOCK_CAR_SEARCH = gql`
  query StockCarSearch(
    $stockIdentifier: StockIdentifierInput!
    $searchParameter: StockCarSearchParameterInput
  ) {
    stockCarSearch(stockIdentifier: $stockIdentifier, searchParameter: $searchParameter) {
      resultNumber
      results {
        cars {
          stockCar {
            id
            vin
            cartypeText
            dynamicAttributes {
              id
              value
            }
            modelInfo {
              genericModel {
                code
                text
              }
            }
          }
        }
      }
    }
  }
`;

export const STOCK_CAR_BY_ID = gql`
  query StockCar($stockCarIdentifier: StockCarIdentifierInput!) {
    stockCar(stockCarIdentifier: $stockCarIdentifier) {
      id
      vin
      dynamicAttributes {
        id
        value
      }
      cartypeText
      modelInfo {
        genericModel {
          code
          text
        }
      }
    }
  }
`;
